module.exports = __webpack_public_path__ + "static/heidi1-b01149789dfb08f8e750a8f9ab27b3fb.jpg";